import { sendAnalyticsEvent } from "../api/analytics";
import { previewQueryPath, normalizePath } from "../paths";

const VISITOR_KEY = "gla_vid";
const SESSION_KEY = "gla_sid";
const SESSION_AT_KEY = "gla_sid_at";
const SESSION_MS = 30 * 60 * 1000;

function uuid() {
  try {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      return crypto.randomUUID();
    }
  } catch {
    // fall through
  }
  return `id_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
}

function read(storage, key) {
  try {
    return storage.getItem(key) || "";
  } catch {
    return "";
  }
}

function write(storage, key, value) {
  try {
    storage.setItem(key, value);
  } catch {
    // private mode / blocked storage
  }
}

export function getVisitorId() {
  let id = read(window.localStorage, VISITOR_KEY);
  if (!id) {
    id = uuid();
    write(window.localStorage, VISITOR_KEY, id);
  }
  return id;
}

export function getSessionId() {
  const now = Date.now();
  const lastAt = Number(read(window.sessionStorage, SESSION_AT_KEY) || 0);
  let id = read(window.sessionStorage, SESSION_KEY);
  if (!id || !lastAt || now - lastAt > SESSION_MS) {
    id = uuid();
    write(window.sessionStorage, SESSION_KEY, id);
  }
  write(window.sessionStorage, SESSION_AT_KEY, String(now));
  return id;
}

function deviceFromWidth() {
  const width = window.innerWidth || 0;
  if (width < 768) return "mobile";
  if (width < 1024) return "tablet";
  return "desktop";
}

function utmFromLocation() {
  try {
    const params = new URLSearchParams(window.location.search);
    return {
      utmSource: params.get("utm_source") || "",
      utmMedium: params.get("utm_medium") || "",
      utmCampaign: params.get("utm_campaign") || "",
    };
  } catch {
    return { utmSource: "", utmMedium: "", utmCampaign: "" };
  }
}

export function trackSiteEvent(type, extra = {}) {
  if (typeof window === "undefined") return;
  if (previewQueryPath()) return;
  const path = normalizePath(extra.path || window.location.pathname || "/");
  const utm = utmFromLocation();
  sendAnalyticsEvent({
    type: type || "pageview",
    visitorId: getVisitorId(),
    sessionId: getSessionId(),
    path,
    title: extra.title || document.title || "",
    referrer: extra.referrer != null ? extra.referrer : document.referrer || "",
    device: deviceFromWidth(),
    width: window.innerWidth || 0,
    ...utm,
  });
}
